<!-- 课程组件 子 小卡片-->
<template>
  <el-col :span="6">
    <div class="live-course">
      <div class="box" @click="gotoVideoCourse(item.course.course_id)">
        <img :src="item.course.course_cover" class="image">
        <div class="box_content">
          <button v-if="item.course.course_price<=0" @click.stop.self="gotoVideoCourse(item.course.course_id)">免费观看
          </button>
          <button v-else>查看详情</button>
        </div>
      </div>
      <div class="class_card_info" @click="gotoVideoCourse(item.course.course_id)">
        <div class="course_title">{{ item.course.course_name }}</div>
        <div style="display: flex;flex-direction: row;margin-top: 15px;align-items: center;justify-content: center">
          <div style="color: #666666;font-size: 11px" v-for="(teacher) in item.course.teachers">
            {{ teacher.teacher_name + '\xa0' }}
          </div>
          <div style="color: #666666;font-size: 12px" v-if="!item.course.teachers">
            {{ '必胜公考教学团队' + '\xa0' }}
          </div>
        </div>
        <div class="oneline">
          <div class="times"><b>{{ item.course.video_num }}</b> 课时</div>
          <div class="people"><b>{{ item.course.subscribe_num }}</b> 人听课</div>
        </div>
      </div>
      <div
        style="background-color: #f2f2f2;width: calc(100vh + 20px);height: 1px;margin-left: -20px;margin-top: 15px;margin-bottom: -20px"/>
    </div>
  </el-col>
</template>

<script>
import RankStars from "./RankStars"

export default {
  name: "class-card",
  props: ['item'],
  components: {
    RankStars
  },
  methods: {
    gotoVideoCourse(course_id) {
      this.$router.push({name: 'Video', params: {course_id: course_id}})
    },
    gotoOrder: function (course_id) {
      this.$router.push({name: 'Order', query: {pId: course_id}})
    },
  }
}
</script>

<style scoped>
@import "../../common/style/classsection.css";

.live-course .classbought:after {
  content: "";
  display: block;
  position: absolute;
  width: 60px;
  height: 60px;
  right: 11px;
  bottom: -14px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  background-image: url(./images/bought.png);
}

.flyello {
  float: right;
  font-size: 12px;
  font-weight: bold;
  color: #e37d28;
  margin-top: 3px;
}

.flmd {
  float: right;
  color: #999;
  font-size: 12px;
  margin-top: 3px;
}

.course_title {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 15px;
  color: #333333;
  margin-top: 15px;
  font-weight: 444;
  width: 277px;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/ClassCard.vue